//
//
//  API
//
//


import {formatDate} from "./utils.ts";

export class RequestError extends Error {

    response: Response

    constructor(response: Response) {
        super()
        this.response = response
    }
}

export function toJsonOrRaise(response: Response) {
    if (!response.ok) {
        throw new RequestError(response)
    }
    return response.json()
}

export function raiseForStatus(response: Response) {
    if (!response.ok) {
        throw new RequestError(response)
    }
    return response
}

class Api {

    static async getConversations(accessToken: string, page: number, size: number, searchTerm?: string){
        const queryParams = new URLSearchParams({
            size: size.toString(),
            page: page.toString()
        })

        if (searchTerm) {
            queryParams.set("search", searchTerm);
        }

        const response = await fetch(
            import.meta.env.VITE_API_URL + "/api/conversations?" + queryParams, 
            {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getMessages(accessToken: string, conversationID: number | string, page: number, size: number) {
        const queryParams = new URLSearchParams({
            size: size.toString(),
            page: page.toString()
        }).toString()

        const response = await fetch(import.meta.env.VITE_API_URL + `/api/conversations/${conversationID}/messages?${queryParams}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getConversation(accessToken: string, conversationID: number | string) {
        const response = await fetch(import.meta.env.VITE_API_URL + `/api/conversations/${conversationID}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getChatWebBot(accessToken: string, botId: string | number) {
        const response = await fetch(import.meta.env.VITE_API_URL + `/api/channels/chatweb/${botId}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getStatsTotalConversations(accessToken: string, agg?: string) {
        const queryParams: Record<string, any> = {}
        if (agg) {
            queryParams["agg"] = agg
        }

        const response = await fetch(import.meta.env.VITE_API_URL + `/api/stats/conversations?` + new URLSearchParams(queryParams), {
              method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getStatsTotalConversationsByDate(accessToken: string, freq?: string, startDate?: Date, endDate?: Date) {
        const queryParams: Record<string, any> = {}
        if (freq) {
            queryParams["freq"] = freq
        }
        if (startDate) {
            queryParams["start_date"] = formatDate(startDate)
        }
        if (endDate) {
            queryParams["end_date"] = formatDate(endDate)
        }

        const response = await fetch(import.meta.env.VITE_API_URL + `/api/stats/conversations-by-date?` + new URLSearchParams(queryParams), {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getStatsTotalConversationsByDateAndChannel(accessToken: string, freq?: string, startDate?: Date, endDate?: Date) {
        const queryParams: Record<string, any> = {}
        if (freq) {
            queryParams["freq"] = freq
        }
        if (startDate) {
            queryParams["start_date"] = formatDate(startDate)
        }
        if (endDate) {
            queryParams["end_date"] = formatDate(endDate)
        }

        const response = await fetch(import.meta.env.VITE_API_URL + `/api/stats/conversations-by-date-and-channel?` + new URLSearchParams(queryParams), {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

    static async getStatsTotalConversationsByDateAndStatus(accessToken: string, freq?: string, startDate?: Date, endDate?: Date) {
        const queryParams: Record<string, any> = {}
        if (freq) {
            queryParams["freq"] = freq
        }
        if (startDate) {
            queryParams["start_date"] = formatDate(startDate)
        }
        if (endDate) {
            queryParams["end_date"] = formatDate(endDate)
        }

        const response = await fetch(import.meta.env.VITE_API_URL + `/api/stats/conversations-by-date-and-status?` + new URLSearchParams(queryParams), {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        })
        return toJsonOrRaise(response)
    }

}

export default Api
